import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Camera } from 'lucide-react';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
import { AvatarPicker } from '../components/AvatarPicker';
import { useAuth } from '../contexts/AuthContext';
export function EditProfilePage() {
  const navigate = useNavigate();
  const {
    user,
    updateUserProfile
  } = useAuth();
  const [name, setName] = useState(user?.displayName || '');
  const [email, setEmail] = useState(user?.email || '');
  const [bio, setBio] = useState('');
  const [avatarUrl, setAvatarUrl] = useState(user?.photoURL || `https://api.dicebear.com/7.x/avataaars/svg?seed=${user?.uid}`);
  const [showAvatarPicker, setShowAvatarPicker] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateUserProfile({
        displayName: name,
        photoURL: avatarUrl
      });
      navigate('/profile');
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const handleAvatarSelect = (url: string) => {
    setAvatarUrl(url);
  };
  return <div className="min-h-screen bg-game-bg-pink dark:bg-[#1a1d29] p-6 pb-24" data-id="element-711">
      <header className="flex items-center gap-4 mb-8" data-id="element-712">
        <Button variant="ghost" size="sm" onClick={() => navigate(-1)} className="!p-2" data-id="element-713">
          <ArrowLeft className="w-6 h-6" data-id="element-714" />
        </Button>
        <h1 className="text-2xl font-fredoka font-bold text-game-dark dark:text-white" data-id="element-715">
          Edit Profile
        </h1>
      </header>

      <form onSubmit={handleSubmit} className="space-y-8 max-w-md mx-auto" data-id="element-716">
        {/* Avatar Upload */}
        <div className="flex flex-col items-center space-y-4" data-id="element-717">
          <div className="relative" data-id="element-718">
            <img src={avatarUrl} alt={name} className="w-32 h-32 rounded-full border-4 border-white dark:border-gray-800 shadow-lg" data-id="element-719" />
            <button type="button" onClick={() => setShowAvatarPicker(true)} className="absolute bottom-0 right-0 bg-game-purple text-white p-3 rounded-full shadow-lg border-4 border-white dark:border-[#1a1d29] hover:bg-game-purple/90 transition-colors" data-id="element-720">
              <Camera className="w-5 h-5" data-id="element-721" />
            </button>
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-400 font-quicksand" data-id="element-722">
            Click to change avatar
          </p>
        </div>

        <Input label="Full Name" placeholder="Your name" value={name} onChange={e => setName(e.target.value)} required data-id="element-723" />

        <Input label="Email" type="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)} disabled data-id="element-724" />

        <div className="space-y-2" data-id="element-725">
          <label className="block font-fredoka font-medium text-game-dark dark:text-white ml-1" data-id="element-726">
            Bio
          </label>
          <textarea value={bio} onChange={e => setBio(e.target.value)} placeholder="Tell us about yourself..." rows={4} className="w-full px-4 py-3 rounded-2xl bg-white dark:bg-[#252936] border-2 border-gray-100 dark:border-gray-700 focus:border-game-purple focus:outline-none font-quicksand text-game-dark dark:text-white placeholder-gray-400 transition-colors resize-none" data-id="element-727" />
        </div>

        <div className="pt-4 space-y-3" data-id="element-728">
          <Button type="submit" className="w-full" size="lg" disabled={loading} data-id="element-729">
            {loading ? 'Saving...' : 'Save Changes'}
          </Button>
          <Button type="button" variant="secondary" className="w-full" onClick={() => navigate(-1)} data-id="element-730">
            Cancel
          </Button>
        </div>
      </form>

      {/* Avatar Picker Modal */}
      {showAvatarPicker && <AvatarPicker currentAvatar={avatarUrl} onSelect={handleAvatarSelect} onClose={() => setShowAvatarPicker(false)} data-id="element-731" />}
    </div>;
}